<template>
  <div>
    <div class="content-header">
      <h1>Plán rozvozu - náhľad pred tlačou</h1>
    </div>
    <div class="content">
      <section>
        <div class="row">
          <div class="col-md-12">
            <div class="block">
              <button class="btn btn-primary hidden-print" @click.prevent="print()">Tlač</button>
              <button class="btn btn-default hidden-print" @click.prevent="back()">Zrušiť</button>
            </div>
          </div>
        </div>
      </section>
      <template v-if="orders && orders.length" v-for="area in areas">
        <section class="print-end-page" v-if="customersByArea(area).length && hasSomeOrderByArea(area)">
          <div class="box">
            <div class="box-header">
              <h3 class="visible-print">Plán rozvozu</h3>
              <h3 class="box-title first">Dátum: <strong>{{ date | date }}</strong></h3>
              <h3 class="box-title" v-if="area">Oblasť: <strong>{{ area.label }}</strong></h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-12">
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>Odberateľ</th>
                      <th class="text-nowrap" v-for="product in validProducts">{{ product.label }}</th>
                      <th>Hotovosť</th>
                      <th>Poznámka</th>
                    </tr>
                    </thead>
                    <tbody>
                      <template v-for="customer in customersByArea(area)">
                        <tr v-if="hasSomeOrderByCustomer(customer)">
                          <td class="text-nowrap" >{{ customer.companyName }}</td>
                          <td v-for="product in validProducts"><span title="Počet objednaných">{{ amount(customer.id, product.id) }}</span></td>
                          <td class="cash">
                            {{ cash(customer.id) | currency }}
                          </td>
                          <td class="note">
                            {{ note(customer.id) }}
                          </td>
                        </tr>
                      </template>
                    </tbody>
                    <tfoot>
                      <tr class="info text-bold">
                        <td>Spolu</td>
                        <td v-for="product in validProducts">{{ count(area, product) }}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </template>
      <loading id="orders"></loading>
      <no-records :data="orders" loadingId="orders"></no-records>
    </div>
  </div>

</template>

<script>
  import _ from 'lodash';
  import { mapState, mapGetters } from 'vuex';
  import loading from 'components/loading';
  import noRecords from 'components/noRecords';

  export default {
    components: {loading, noRecords},
    computed: {
      ...mapGetters({
        customers: 'customer/filteredItems',
        validProducts: 'product/validItems'
      }),
      ...mapState({
        date: (state) => state.order.filterDate,
        areas: (state, getters) => state.customer.filter.area ? [state.customer.filter.area] : getters['area/validItems'],
        orders(state) {
          return state.order.items;
        }
      }),
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      print() {
        window.print();
      },
      customersByArea(area) {
          return _(this.customers)
            .filter((customer) => customer.area.id === area.id)
            .sortBy((customer) => customer.sortOrder)
            .value();
      },
      cash(customerId) {
        const order = this.order(customerId);
        return order ? order.cash : null;
      },
      note(customerId) {
        const order = this.order(customerId);
        return order ? order.note : '';
      },
      amount(customerId, productId) {
        const orderItem = this.orderItem(customerId, productId);
        return orderItem ? orderItem.amount : 0;
      },
      count(area, product) {
        return  _(this.orders)
          .filter(order => order.customer.area.id === area.id)
          .flatMap('items')
          .filter(orderItem => orderItem.product.id === product.id)
          .sumBy('amount');
      },
      order(customerId) {
        return this.orders.find(order => order.customer.id === customerId);
      },
      orderItem(customerId, productId) {
        const order = this.order(customerId);
        if (order) {
          const orderItem = order.items.find(orderItem => orderItem.product.id === productId);
          if (orderItem) {
            return orderItem;
          }
        }
        return null;
      },
      hasSomeOrderByArea(area) {
        return _.filter(this.orders, (order) => order.customer.area.id === area.id).length;
      },
      hasSomeOrderByCustomer(customer) {
        return _.filter(this.orders, (order) => order.customer.id === customer.id).length;
      },
      fetch() {
        this.$store.dispatch('order/findByDate');
      }
    },
    created () {
      this.$store.dispatch('customer/getAll');
      this.$store.dispatch('product/getAll');
      this.$store.dispatch('area/getAll');
    },
    mounted () {
      this.fetch();
    }
  };
</script>



// WEBPACK FOOTER //
// client/views/ordersPrint.vue